import { Link, useLocation } from "react-router-dom";
import { navbarIcons } from "shared/data/portfolioData";
import Icon from "../Icons/Icon";
import styles from "./Navbar.module.css";

const Navbar = ({ navItems }) => {
  const location = useLocation();

  return (
    <div className={styles.navbarContainer}>
      <nav className={styles.navbar} aria-label="Primary navigation">
        <ul className={styles.iconRow}>
          {navItems.map((item) => (
            <li key={item.path}>
              <Link to={item.path} aria-label={item.alt}>
                <Icon
                  src={navbarIcons[item.name]}
                  alt={item.alt}
                  isActive={location.pathname === item.path}
                />
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
